var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.902,
    height: 43.32,
    viewBox: "0 0 37.902 43.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(-3242.236 -6873.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M3276.671,6916.784H3245.7a.477.477,0,0,0-.11-.058,3.979,3.979,0,0,1-3.352-4.187q0-17.427,0-34.855a4,4,0,0,1,4.218-4.219q8.524,0,17.05,0h.483v.55q0,5.667,0,11.336a5.171,5.171,0,0,0,.119,1.173,3.983,3.983,0,0,0,4.072,3.078q5.712.009,11.423,0h.527v21.58c0,.578.013,1.157-.008,1.734a4,4,0,0,1-2.769,3.675C3277.131,6916.666,3276.9,6916.721,3276.671,6916.784Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M3266.527,6874.333l12.715,12.708c-.09.007-.209.023-.328.023q-5.349,0-10.7,0a1.5,1.5,0,0,1-1.689-1.694q0-5.349,0-10.7Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/controls.86e2c5aa24cf5b7b9f8d0fdefca5e636.svg";
export { ForwardRef as ReactComponent };